import { useEffect, useState } from "react";
import { Input } from "./ui";

/**
 * Debounced so typing a name does not fire a query per keystroke. The input
 * stays controlled locally; only the settled value is lifted.
 */
export function SearchInput({
  value,
  onChange,
  placeholder,
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}) {
  const [draft, setDraft] = useState(value);

  // Adopt external resets (clearing a filter) without clobbering live typing.
  useEffect(() => {
    setDraft((current) => (value === "" && current !== "" ? "" : current));
  }, [value]);

  useEffect(() => {
    if (draft === value) return;
    const timer = setTimeout(() => onChange(draft), 250);
    return () => clearTimeout(timer);
  }, [draft, value, onChange]);

  return (
    <Input
      type="search"
      value={draft}
      placeholder={placeholder ?? "Search…"}
      onChange={(event) => setDraft(event.target.value)}
      className="sm:max-w-xs"
    />
  );
}
